import { DragDropContext } from '@hello-pangea/dnd';
import { FilterWrapper } from '../style';
import { useHotkeys } from 'react-hotkeys-hook';
import { Renderers } from './TransformationTypes/Renderers';

const ConditionBody = ({
  onSave,
  extractId,

  columns,
  addCondition,
  onSelectItem,

  disableSaveBtn,
  tranformationId,
  selectedItems,
  selectedTransformation,
  filterTypes,
  onChangeThen,
  onChangeInput,
  onChangeColumn,
  isChildrenGroup,
  tableName,
  onAddFilterType,
  onChangeFunction,
  onChangeInputType,
  parentFilterTypeId,
  onToggleColumnItem,
  onChangeOperator,
  onChangeElseValue,
  onChangeElseInputType,
  onToggleColumnItem2,
  onClearColumns,
  onClearColumns2,
  onChangeReplaceColumn,
  cuurentItem,
  onSelectCondition,
  onChangeSelectedColumns,
  handleDragEnd,
  onDeleteSelectedItems,
  onChangeThenInputType,
  onChangeKeep,
  changeColumnsCount,
  onChangeSingleColumn,
  onAddListItem,
  onRemoveListItem,
  stepIn,

  periodId,
  workflowId,
  onChangeColumnsCount,
  onChangeUpdateType,
  onChangeShiftingMethod,
  onChangePeriodAmount,
  onChangeTimePeriod,
  onChangeColumnName,
  periodName,
  onChangeCurrentFormats,
  onChangeOutputFormat,
  onChangeFuzzyMatching,
  onChangeNumberOfSplits,
  onChangeDirection,
  onChangeExpandedNewColumns,
  onChangeBrowserUse
}) => {
  useHotkeys(
    'enter',
    () => {
      if (!disableSaveBtn) onSave();
    },
    [disableSaveBtn]
  );

  const Renderer = Renderers[cuurentItem?.label];
  const rootId = cuurentItem?.id
    ? `grid-table-condition-body-root-${cuurentItem.id}`
    : 'grid-table-condition-body-root';

  return (
    <DragDropContext onDragEnd={e => handleDragEnd(e, parentFilterTypeId)}>
      <FilterWrapper id={rootId} isChildrenGroup={isChildrenGroup}>
        <Renderer
          id={`${rootId}-renderer`}
          periodName={periodName}
          selectedTransformation={selectedTransformation}
          extractId={extractId}
          tableName={tableName}
          workflowId={workflowId}
          periodId={periodId}
          onChangeOperator={onChangeOperator}
          onChangeThenInputType={onChangeThenInputType}
          onChangeThen={onChangeThen}
          onSelectItem={onSelectItem}
          item={cuurentItem}
          stepIn={stepIn}
          columns={columns}
          onChangeKeep={onChangeKeep}
          tranformationId={tranformationId}
          column={cuurentItem?.column}
          onClearColumns={onClearColumns}
          onClearColumns2={onClearColumns2}
          isChildrenGroup={isChildrenGroup}
          cuurentItem={cuurentItem}
          filterTypes={filterTypes}
          onSelectCondition={onSelectCondition}
          parentFilterTypeId={parentFilterTypeId}
          onDeleteSelectedItems={onDeleteSelectedItems}
          onAddFilterType={onAddFilterType}
          onChangeElseInputType={onChangeElseInputType}
          onToggleColumnItem2={onToggleColumnItem2}
          onChangeElseValue={onChangeElseValue}
          addCondition={addCondition}
          onChangeReplaceColumn={onChangeReplaceColumn}
          selectedItems={selectedItems}
          onChangeFunction={onChangeFunction}
          onChangeInputType={onChangeInputType}
          onChangeInput={onChangeInput}
          onChangeColumn={onChangeColumn}
          onToggleColumnItem={onToggleColumnItem}
          changeColumnsCount={changeColumnsCount}
          onChangeSingleColumn={onChangeSingleColumn}
          onAddListItem={onAddListItem}
          onRemoveListItem={onRemoveListItem}
          onChangeColumnsCount={onChangeColumnsCount}
          onChangeUpdateType={onChangeUpdateType}
          onChangeShiftingMethod={onChangeShiftingMethod}
          onChangePeriodAmount={onChangePeriodAmount}
          onChangeTimePeriod={onChangeTimePeriod}
          onChangeColumnName={onChangeColumnName}
          onChangeSelectedColumns={onChangeSelectedColumns}
          onChangeCurrentFormats={onChangeCurrentFormats}
          onChangeOutputFormat={onChangeOutputFormat}
          onChangeFuzzyMatching={onChangeFuzzyMatching}
          onChangeNumberOfSplits={onChangeNumberOfSplits}
          onChangeDirection={onChangeDirection}
          onChangeExpandedNewColumns={onChangeExpandedNewColumns}
          onChangeBrowserUse={onChangeBrowserUse}
        />
      </FilterWrapper>
    </DragDropContext>
  );
};

export default ConditionBody;
